import clsx from 'clsx'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import type { AnnouncementDetailModalProps } from './type'

import { DocumentationContent } from '@/components/documentation'
import { Dialog, TextButton } from '@/components/ui'
import { formatDate } from '@/utils/date'

import styles from './style.module.css'

export const AnnouncementDetailModal = ({
  isOpen,
  title,
  announcementDate,
  content,
  children,
  onClose,
}: AnnouncementDetailModalProps) => {
  const { t } = useTranslation()
  const date = formatDate(announcementDate, 'yyyy-MM-dd')
  const ref = useRef(null)
  return (
    <Dialog
      title={t('announcement.title')}
      isOpen={isOpen}
      initialFocus={ref}
      onClose={onClose}
    >
      <div className={clsx('tw-px-2 tw-pb-2 tw-text-sm')} ref={ref}>
        <div className={clsx('tw-text-gray-600')}>{date}</div>
        <div className={clsx('tw-font-bold')}>{title}</div>
        <div className={clsx('tw-mt-4', styles.cancelContentPaddingX)}>
          {content && <DocumentationContent document={content} />}
          {children}
        </div>
        <div className={clsx('tw-mt-4 tw-flex tw-justify-center')}>
          <TextButton onClick={onClose}>{t('announcement.close')}</TextButton>
        </div>
      </div>
    </Dialog>
  )
}
